import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { colors } from "../../ui/colors";

interface LabelWithHelpProps {
  label?: string;
  helpText: string;
}

export const LabelWithHelp = ({ label = "", helpText }: LabelWithHelpProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "var(--fx-surface-text, #0F172A)",
          fontWeight: 600,
        }}
      >
        {label}
      </Typography>

      <Tooltip
        title={helpText}
        arrow
        placement="top"
        PopperProps={{
          sx: {
            zIndex: 9999999, 
          },
        }}
      >
        <IconButton
          size="small"
          sx={{
            p: 0.3,
            color: "text.secondary",
            "&:hover": {
              color: colors.orange.base,
            },
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
